import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/guide-tips/photochromic-lenses/photochromic-lenses.tsx");
